import { message } from "antd";
import { makeObservable, observable } from "mobx";
import { get, post } from "../../services/request";
import {
  GET_ALLAPP_BY_USER,
  GET_DETAILS,
  GET_TAG,
  ADD_TAG,
  REMOVE_TAG,
  EDIT_TAG_NAME,
} from "../../services/request/urls";

export interface ProjectItem {
  id: number;
  name: string;
  des: string;
  spellType: string;
  otherTag: string;
  refUrlAppVoList: {
    id: number;
    name: string;
    pictureUrl: string;
    key: string;
    des: string;
    type?: number[];
  }[];
}
export interface TagItem {
  id: number;
  name: string;
  type: string;
}

class AppStore {
  projects: ProjectItem[] = [];
  typeCur: number = 0;
  versionTypeCur: number = 0;

  details: string = "";
  otherTag: TagItem[] = [];
  industryTag: TagItem[] = [];

  constructor() {
    makeObservable(this, {
      projects: observable,
      typeCur: observable,
      details: observable,
      otherTag: observable,
      industryTag: observable,
      versionTypeCur: observable,
    });
  }

  async getAppPictureList(
    obj: {
      name: string;
      industryTag: string;
      otherTag: string[];
    } = {
      name: "",
      industryTag: "",
      otherTag: [],
    }
  ) {
    if (obj.industryTag === "0") obj.industryTag = "";
    if (obj.otherTag.includes("0")) obj.otherTag = [];
    const res = await post(GET_ALLAPP_BY_USER, obj, true);

    if (res?.code !== 1) {
      message.error(res?.message ?? "获取应用场景列表失败");
      return;
    }
    this.projects = res.data;
  }

  async getTag(name: string = "", type: string = "") {
    if (!type) {
      const res1 = await post(GET_TAG, { name, type: "1" }, true);
      if (res1?.code !== 1) {
        message.error(res1?.message ?? "获取行业标签列表失败");
        return;
      }
      this.industryTag = res1.data ?? [];
      const res2 = await post(GET_TAG, { name: "", type: "2" }, true);
      if (res2?.code !== 1) {
        message.error(res2?.message ?? "获取版本标签列表失败");
        return;
      }
      this.otherTag = res2.data ?? [];
      this.versionTypeCur = res2.data?.[0]?.id ?? 0;
    } else {
      const res = await post(GET_TAG, { name, type }, true);
      if (res?.code !== 1) {
        message.error(res?.message ?? "获取标签列表失败");
        return;
      }
      if (type === "1") this.industryTag = res.data ?? [];
      else {
        this.otherTag = res.data ?? [];
        this.versionTypeCur = res.data?.[0]?.id ?? 0;
      }
    }
  }
  async addTag(type: string, name: string[]) {
    const res = await post(ADD_TAG, { name, type }, true);
    console.log(res, "tag");
    if (res?.code !== 1) {
      message.error(res?.message ?? "新增失败");
      return;
    }
    await this.getTag();
  }
  async editTag(id: string, name: string) {
    const res = await post(EDIT_TAG_NAME, { id, name }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "编辑失败");
      return;
    }
    await this.getTag();
  }
  async removeTag(id: string, type: string) {
    const res = await post(REMOVE_TAG + "?id=" + id + "&type=" + type, null, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "删除失败");
      return;
    }
    await this.getTag();
  }
  async getDetails(key: string) {
    if (!key) return;
    const res = await get(GET_DETAILS + "?key=" + key, null, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "获取描述详情失败");
      return;
    }
    this.details = res.data ?? "";
  }

  setTypeCur(type: number) {
    this.typeCur = type;
  }

  setVersionTypeCur(type: number) {
    this.versionTypeCur = type;
  }
}

export default new AppStore();
